import React from 'react'
import '../assets/css/Resume.css'
import python from '../assets/icons/python.svg'
const data = [
    {
        icon: 'python',
        name: 'python',
        level: '50'
    },
    {
        icon: 'python',
        name: 'python',
        level: '50'
    },
    {
        icon: 'python',
        name: 'python',
        level: '50'
    },
    {
        icon: 'python',
        name: 'python',
        level: '50'
    },
];
const tools = [
    {
        icon: 'python',
        name: 'GIMP for editing images',
        level: '50'
    },
    {
        icon: 'python',
        name: 'python',
        level: '50'
    },

];
const Resume = () => {
    return (
        <div className="conatiner resume">

            <div className="row">
                <div className="col-lg-6 resume-card">
                    <h4 className="resume-card__heading">Education</h4>
                    <div className="resume-card__body">
                        <h5 className="resume-card__title">Computer Science</h5>
                        <p className="resume-card__name">Faculty of computers and Informatics</p>
                        <p className="resume-card__details">about</p>

                    </div>
                </div>
                <div className="col-lg-6 resume-card">
                    <h4 className="resume-card__heading">Education</h4>
                    <div className="resume-card__body">
                        <h5 className="resume-card__title">Computer Science</h5>
                        <p className="resume-card__name">Faculty of computers and Informatics</p>
                        <p className="resume-card__details">about</p>

                    </div>
                </div>


            </div>

            <div className="row">
                <div className="col-lg-6 resume-languages">
                    <h4 className="resume-language__heading">Languages & Frameworks</h4>
                    <div className="resume-language__body">
                        {

                        }

                    </div>
                </div>

                <div className="col-lg-6 resume-languages">
                    <h4 className="resume-language__heading">tools & software</h4>
                    <div className="resume-language__body">


                    </div>
                </div>
            </div>
        </div>
    )
}

export default Resume
